const MAIN_KEY = 'slot';

export const TYPE_MAIN_TOP = `${MAIN_KEY}-1`;
export const TYPE_MAIN_BOTTOM = `${MAIN_KEY}-2`;

export const TYPE_SEARCH_TOP = `${MAIN_KEY}-3`;
export const TYPE_SEARCH_SIDEBAR = `${MAIN_KEY}-4`;
export const TYPE_SEARCH_BOTTOM = `${MAIN_KEY}-5`;

export const TYPE_PLAYER_PAGE_TOP = `${MAIN_KEY}-6`;
export const TYPE_PLAYER_PAGE_BOTTOM = `${MAIN_KEY}-7`;

export const TYPE_CHANNEL_VIEW_TOP = `${MAIN_KEY}-8`;
export const TYPE_CHANNEL_VIEW_BOTTOM = `${MAIN_KEY}-9`;

export const ALL_TYPES = [
  TYPE_MAIN_TOP,
  TYPE_MAIN_BOTTOM,
  TYPE_SEARCH_TOP,
  TYPE_SEARCH_SIDEBAR,
  TYPE_SEARCH_BOTTOM,
  TYPE_PLAYER_PAGE_TOP,
  TYPE_PLAYER_PAGE_BOTTOM,
  TYPE_CHANNEL_VIEW_TOP,
  TYPE_CHANNEL_VIEW_BOTTOM,
];
